const brandDisplayText = (value) => String(value ?? '')
  .replace(/\bBroken Blueprint\b/g, 'Saint Mykonos')
  .replace(/\bBROKEN BLUEPRINT\b/g, 'SAINT MYKONOS')
  .replace(/\bMy Blueprint\b/g, 'Dashboard')
  .replace(/\bMY BLUEPRINT\b/g, 'DASHBOARD')
  .replace(/\bBlueprint Credit\b/g, 'Mykonos Credit')
  .replace(/\bBLUEPRINT CREDIT\b/g, 'MYKONOS CREDIT')
  .replace(/\bTIER POINTS\b/g, 'TIER MP')
  .replace(/\bSPENDABLE POINTS\b/g, 'SPENDABLE MP')
  .replace(/\bBlueprint Points\b/g, 'Mykonos Points')
  .replace(/\bTier Points\b/g, 'Tier MP')
  .replace(/\bSpendable Points\b/g, 'Spendable MP')
  .replace(/\bBP\b/g, 'MP');

const rewardsStatus = (root, message, isError = false) => {
  const status = root.querySelector('[data-bb-rewards-status]');
  if (!status) return;
  status.textContent = brandDisplayText(message);
  status.dataset.error = String(isError);
};

const formatPoints = (value) => Number(value || 0).toLocaleString(undefined, { maximumFractionDigits: 0 });

// Presentation only, invoked after the existing endpoint confirms issuance.
const showRedemptionConfirmation = (root, message) => {
  root.querySelector('.bb-rewards-confirmation')?.remove();
  const dialog = document.createElement('dialog');
  dialog.className = 'bb-rewards-confirmation';
  dialog.setAttribute('aria-label', 'Loyalty redemption confirmed');
  const panel = document.createElement('div');
  panel.className = 'bb-rewards-confirmation__panel';
  const heading = document.createElement('h2');
  const check = document.createElement('span');
  check.className = 'bb-rewards-confirmation__check';
  check.setAttribute('aria-hidden', 'true');
  check.textContent = '✓';
  heading.append(check, 'LOYALTY CLAIM ISSUED');
  const body = document.createElement('p');
  body.textContent = brandDisplayText(message);
  const close = document.createElement('button');
  close.type = 'button';
  close.textContent = 'DONE';
  close.addEventListener('click', () => dialog.close());
  dialog.addEventListener('close', () => dialog.remove(), {once: true});
  panel.append(heading, body, close);
  dialog.append(panel);
  root.append(dialog);
  dialog.showModal();
  window.BBMotion?.play(panel, [{opacity: 0, scale: .97}, {opacity: 1, scale: 1}], 'state');
  window.BBMotion?.play(check, [{opacity: 0}, {opacity: 1}], 'success');
};

const activityLabel = (entry) => {
  const labels = {
    order_earn: entry?.metadata?.orderName ? `Order ${entry.metadata.orderName}` : 'Order points',
    signup: 'Account created',
    referral_earn: 'Referred a friend',
    referral_reversal: 'Referral adjustment',
    refund_reversal: 'Refund adjustment',
    cancellation_reversal: 'Cancellation adjustment',
    redemption_reserve: 'Loyalty redemption',
    redemption_release: 'Failed redemption restored',
    profile_completion: 'Profile completed',
    email_opt_in: 'Email opt-in',
    monthly_check_in: 'Monthly check-in',
    post_purchase_survey: 'Post-purchase survey',
  };
  return labels[entry?.type] || 'Loyalty adjustment';
};

const renderCanonicalTiers = (root, profile) => {
  const track = root.querySelector('[data-bb-tier-track]');
  if (!track || !Array.isArray(profile.tiers)) return;
  const fragment = document.createDocumentFragment();

  profile.tiers.forEach((tier) => {
    const card = document.createElement('article');
    card.className = `bb-rewards-tier${tier.key === profile.currentTierKey ? ' is-current' : ''}`;
    card.dataset.tierKey = tier.key;

    const mark = document.createElement('span');
    mark.className = 'bb-rewards-tier__mark';
    mark.setAttribute('aria-hidden', 'true');
    mark.dataset.icon = tier.icon || 'star';
    mark.textContent = '✦';

    const heading = document.createElement('h3');
    heading.textContent = tier.name;
    const range = document.createElement('p');
    range.textContent = brandDisplayText(tier.qualificationLabel || tier.rangeLabel);
    const benefits = document.createElement('div');
    (tier.benefits || []).forEach((benefit, index) => {
      if (index) benefits.append(document.createElement('br'));
      benefits.append(document.createTextNode(brandDisplayText(benefit)));
    });

    card.append(mark, heading, range, benefits);
    fragment.append(card);
  });

  track.replaceChildren(fragment);
};

const renderCanonicalRewards = (root, profile) => {
  if (!Array.isArray(profile.rewards)) return;
  const track = root.querySelector('.bb-rewards-redeem__track');
  if (!track) return;
  const authenticated = root.dataset.customerAuthenticated === 'true';
  const balance = Number(profile.spendableBp ?? profile.balance);
  const hasBalance = Number.isFinite(balance);
  const fragment = document.createDocumentFragment();

  profile.rewards.forEach((reward) => {
    const card = document.createElement('article');
    card.className = 'bb-reward-card';
    card.dataset.bbRewardCard = reward.key;
    const icon = document.createElement('span');
    icon.className = 'bb-rewards-icon';
    icon.setAttribute('aria-hidden', 'true');
    icon.textContent = '◇';
    const heading = document.createElement('h3');
    heading.textContent = brandDisplayText(reward.title);
    const cost = document.createElement('strong');
    cost.textContent = `${formatPoints(reward.pointsCost)} MP`;
    const detail = document.createElement('small');
    detail.className = 'bb-reward-card__detail';
    detail.textContent = reward.minimumSpendUsd
      ? `$${formatPoints(reward.minimumSpendUsd)} MINIMUM ELIGIBLE SPEND`
      : brandDisplayText(reward.description || '');
    const button = document.createElement('button');
    button.type = 'button';
    button.dataset.bbRedeem = '';
    button.dataset.rewardCode = reward.key;
    button.dataset.endpoint = root.dataset.redeemEndpoint || '';
    const affordable = reward.affordable ?? (hasBalance && balance >= reward.pointsCost);
    button.disabled = !reward.available || !authenticated || !affordable;
    if (!reward.available) button.textContent = 'UNAVAILABLE';
    else if (!authenticated) button.textContent = 'SIGN IN';
    else if (!affordable) button.textContent = hasBalance
      ? `NEED ${formatPoints(Math.max(0, reward.pointsCost - balance))} MP`
      : 'CHECKING BALANCE';
    else button.textContent = reward.requiresSelection ? 'SELECT TEE' : 'REDEEM';
    if (reward.claimState === 'usable' && reward.claim?.code) {
      detail.textContent = `USABLE CODE: ${reward.claim.code}`;
    } else if (reward.claimState === 'used') {
      detail.textContent = 'LAST CLAIM USED';
    }
    card.append(icon, heading, cost, detail, button);
    fragment.append(card);
  });
  track.replaceChildren(fragment);
};

const renderCanonicalActivity = (root, profile) => {
  const list = root.querySelector('[data-bb-activity-list]');
  if (!list || !Array.isArray(profile.recentActivity)) return;
  if (!profile.recentActivity.length) {
    const empty = document.createElement('p');
    empty.textContent = 'Your verified loyalty activity will appear here.';
    list.replaceChildren(empty);
    return;
  }

  const fragment = document.createDocumentFragment();
  profile.recentActivity.slice(0, 4).forEach((entry) => {
    const item = document.createElement('article');
    const label = document.createElement('span');
    const points = document.createElement('strong');
    label.textContent = activityLabel(entry);
    points.textContent = `${entry.points > 0 ? '+' : ''}${formatPoints(entry.points)} MP`;
    item.append(label, points);
    fragment.append(item);
  });
  list.replaceChildren(fragment);
};

const renderCanonicalReferral = (root, profile) => {
  const slot = root.querySelector('[data-bb-referral-slot]');
  if (!slot) return;
  if (!profile.referralCode || !profile.referralUrl) {
    const link = document.createElement('a');
    link.href = '/pages/my-blueprint#profile';
    link.textContent = 'CHOOSE A USERNAME TO ACTIVATE YOUR REFERRAL LINK →';
    slot.replaceChildren(link);
    return;
  }
  const actions = document.createElement('div');
  actions.className = 'bb-rewards-referral__actions';
  const code = document.createElement('code');
  code.dataset.bbReferralCode = '';
  code.textContent = profile.referralCode;
  const copy = document.createElement('button');
  copy.type = 'button';
  copy.dataset.bbCopyReferral = '';
  copy.dataset.referralUrl = profile.referralUrl;
  copy.textContent = 'COPY LINK';
  const share = document.createElement('button');
  share.type = 'button';
  share.dataset.bbShareReferral = '';
  share.dataset.referralUrl = profile.referralUrl;
  share.textContent = 'SHARE';
  actions.append(code, copy, share);
  const friendPass = profile.program?.friendPass;
  if (friendPass) {
    const note = document.createElement('small');
    note.className = 'bb-rewards-referral__friend-pass';
    note.textContent = profile.currentTierKey === 'outsider'
      ? 'FRIEND PASS UNLOCKS AT UNAFFILIATED.'
      : `FRIEND PASS ACTIVE · UP TO ${friendPass.maxFriends} DISTINCT FRIENDS.`;
    actions.append(note);
  }
  slot.replaceChildren(actions);
};

const renderEarningActions = (root, payload) => {
  const list = root.querySelector('[data-bb-earning-actions]');
  if (!list) return;
  const fragment = document.createDocumentFragment();
  const entries = [
    ...(Array.isArray(payload?.automaticEarning) ? payload.automaticEarning.map((item) => ({...item, automatic: true})) : []),
    ...(Array.isArray(payload?.actions) ? payload.actions : []),
    ...(Array.isArray(payload?.externalActions) ? payload.externalActions.map((item) => ({...item, external: true, available: true})) : []),
    ...(Array.isArray(payload?.unsupported) ? payload.unsupported.map((item) => ({...item, unsupported: true, available: false, description: item.reason})) : []),
  ];
  if (!entries.length) {
    const empty = document.createElement('p');
    empty.textContent = 'No verified earning actions are available right now.';
    list.replaceChildren(empty);
    return;
  }

  entries.forEach((action) => {
    const item = document.createElement('article');
    item.className = `bb-rewards-earn__item${action.state === 'claimed' ? ' is-complete' : action.state === 'locked' ? ' is-disabled' : ''}`;
    item.dataset.bbEarnAction = action.key;
    const icon = document.createElement('span');
    icon.className = 'bb-rewards-icon';
    icon.setAttribute('aria-hidden', 'true');
    icon.textContent = action.state === 'claimed' ? '✓' : action.unsupported ? '—' : action.automatic ? '↻' : '+';
    const copy = document.createElement('span');
    const title = document.createElement('strong');
    title.textContent = brandDisplayText(action.title);
    const detail = document.createElement('small');
    detail.textContent = brandDisplayText(action.description);
    copy.append(title, detail);

    if (!action.automatic && action.rewardBp) {
      const reward = document.createElement('em');
      reward.textContent = `+${formatPoints(action.rewardBp)} SPENDABLE MP · NO TIER MP`;
      copy.append(reward);
    }

    if (action.key === 'post-purchase-survey' && action.available) {
      const controls = document.createElement('span');
      controls.className = 'bb-rewards-earn__controls';
      const order = document.createElement('select');
      order.dataset.bbSurveyOrder = '';
      order.setAttribute('aria-label', 'Eligible fulfilled order');
      (action.eligibleOrders || []).forEach((eligibleOrder) => {
        const option = document.createElement('option');
        option.value = eligibleOrder.id;
        option.textContent = eligibleOrder.name;
        order.append(option);
      });
      const rating = document.createElement('select');
      rating.dataset.bbSurveyRating = '';
      rating.setAttribute('aria-label', 'Order rating');
      [5, 4, 3, 2, 1].forEach((value) => {
        const option = document.createElement('option');
        option.value = String(value);
        option.textContent = `${value} / 5`;
        rating.append(option);
      });
      controls.append(order, rating);
      copy.append(controls);
    }

    item.append(icon, copy);
    if (action.external) {
      const link = document.createElement('a');
      link.href = action.href;
      link.textContent = 'SUBMIT';
      item.append(link);
    } else if (!action.automatic) {
      const button = document.createElement('button');
      button.type = 'button';
      button.dataset.bbClaimAction = action.key;
      button.disabled = !action.available;
      button.textContent = action.unsupported ? (action.key === 'drop-reminder' ? 'COMING SOON' : 'NOT SUPPORTED') : action.claimed ? 'CLAIMED ✓' : action.available ? 'CLAIM' : action.key === 'email-opt-in' ? 'CONSENT REQUIRED' : action.key === 'profile-completion' ? 'PROFILE REQUIRED' : 'LOCKED';
      item.append(button);
    }
    fragment.append(item);
  });
  list.replaceChildren(fragment);
};

const loadEarningActions = async (root) => {
  if (globalThis.Shopify?.designMode || root.dataset.backendReady !== 'true' || root.dataset.customerAuthenticated !== 'true') return;
  const endpoint = root.dataset.actionsEndpoint;
  if (!endpoint) return;
  const list = root.querySelector('[data-bb-earning-actions]');
  list?.setAttribute('aria-busy', 'true');
  try {
    const response = await fetch(endpoint, {credentials: 'same-origin', headers: {Accept: 'application/json'}});
    const payload = await response.json().catch(() => ({}));
    if (!response.ok) throw new Error(payload.message || 'Earning actions are temporarily unavailable.');
    renderEarningActions(root, payload);
  } catch (error) {
    if (list) {
      const message = document.createElement('p');
      message.textContent = brandDisplayText(error.message || 'Earning actions are temporarily unavailable.');
      list.replaceChildren(message);
    }
  } finally {
    list?.removeAttribute('aria-busy');
  }
};

const renderLeaderboard = (root, payload) => {
  const list = root.querySelector('[data-bb-leaderboard-list]');
  if (!list) return;
  const entries = Array.isArray(payload?.entries) ? payload.entries.slice(0, 5) : [];
  if (!entries.length) {
    const empty = document.createElement('p');
    empty.textContent = 'Leaderboard places appear after members choose a public username.';
    list.replaceChildren(empty);
    return;
  }

  const fragment = document.createDocumentFragment();
  entries.forEach((entry) => {
    const row = document.createElement('article');
    row.className = `bb-rewards-leaderboard__row${entry.isCurrentMember ? ' is-current' : ''}`;
    row.dataset.rank = String(entry.rank || '');

    const rank = document.createElement('strong');
    rank.className = 'bb-rewards-leaderboard__rank';
    rank.textContent = String(entry.rank || '—').padStart(2, '0');

    const avatar = document.createElement(entry.avatarUrl ? 'img' : 'span');
    avatar.className = 'bb-rewards-leaderboard__avatar';
    if (entry.avatarUrl) {
      avatar.src = entry.avatarUrl;
      avatar.alt = '';
      avatar.loading = 'lazy';
    } else {
      avatar.textContent = String(entry.username || 'SM').slice(0, 2).toUpperCase();
      avatar.setAttribute('aria-hidden', 'true');
    }

    const identity = document.createElement('span');
    identity.className = 'bb-rewards-leaderboard__identity';
    const username = document.createElement('b');
    username.textContent = `@${entry.username || 'member'}`;
    const tier = document.createElement('small');
    tier.textContent = entry.tier || 'MEMBER';
    identity.append(username, tier);

    const points = document.createElement('span');
    points.className = 'bb-rewards-leaderboard__points';
    const score = document.createElement('b');
    score.textContent = formatPoints(entry.score);
    const unit = document.createElement('small');
    unit.textContent = 'MP';
    points.append(score, ' ', unit);
    row.append(rank, avatar, identity, points);
    fragment.append(row);
  });
  list.replaceChildren(fragment);
};

const loadLeaderboard = async (root, period = 'current-season') => {
  const list = root.querySelector('[data-bb-leaderboard-list]');
  if (!list || root.dataset.customerAuthenticated !== 'true') return;
  const endpoint = root.dataset.leaderboardEndpoint;
  if (!endpoint) return;
  list.setAttribute('aria-busy', 'true');
  try {
    const url = new URL(endpoint, window.location.origin);
    url.searchParams.set('period', period);
    const response = await fetch(url, {credentials: 'same-origin', headers: {Accept: 'application/json'}});
    const payload = await response.json().catch(() => ({}));
    if (!response.ok) throw new Error(payload.message || 'Leaderboard is temporarily unavailable.');
    renderLeaderboard(root, payload);
  } catch (error) {
    const message = document.createElement('p');
    message.textContent = brandDisplayText(error.message || 'Leaderboard is temporarily unavailable.');
    list.replaceChildren(message);
  } finally {
    list.removeAttribute('aria-busy');
  }
};

const hydrateVerifiedProfile = (root, profile) => {
  root.dataset.profileVerified = 'true';
  root.querySelector('.bb-rewards-signin')?.remove();

  const currentTier = root.querySelector('[data-bb-current-tier]');
  const tierPoints = root.querySelector('[data-bb-tier-points]');
  const balance = root.querySelector('[data-bb-balance]');
  const nextTier = root.querySelector('[data-bb-next-tier]');
  const nextTierLabel = root.querySelector('[data-bb-next-tier-label]');
  if (currentTier) currentTier.textContent = profile.tier;
  if (tierPoints) tierPoints.textContent = `${formatPoints(profile.tierPoints ?? profile.qualifiedPoints)} MP`;
  if (balance) balance.textContent = `${formatPoints(profile.spendableBp ?? profile.balance)} MP`;
  if (nextTier) nextTier.textContent = profile.nextTier || 'MAX TIER';
  if (nextTierLabel) nextTierLabel.textContent = profile.nextTier ? 'NEXT TIER' : 'STATUS';

  const progress = Math.max(0, Math.min(1, Number(profile.progress) || 0));
  const progressBar = root.querySelector('[data-bb-progress-bar]');
  const progressFill = root.querySelector('[data-bb-progress-fill]');
  const progressLabel = root.querySelector('[data-bb-progress-label]');
  const progressValue = root.querySelector('[data-bb-progress-value]');
  const nextDefinition = profile.tiers?.find((tier) => tier.key === profile.nextTierKey);
  if (progressBar) {
    progressBar.classList.remove('bb-rewards-progress__locked');
    progressBar.removeAttribute('aria-hidden');
    progressBar.setAttribute('role', 'progressbar');
    progressBar.setAttribute('aria-valuemin', '0');
    progressBar.setAttribute('aria-valuemax', '100');
    progressBar.setAttribute('aria-valuenow', String(Math.round(progress * 100)));
  }
  if (progressFill) progressFill.style.width = `${progress * 100}%`;
  if (progressLabel) progressLabel.textContent = profile.nextTier ? `${formatPoints(profile.pointsToNext)} MP to next tier` : 'Highest tier achieved';
  if (progressValue) progressValue.textContent = `${formatPoints(profile.qualifiedPoints)}${nextDefinition ? ` / ${formatPoints(nextDefinition.threshold)}` : ''} TIER MP`;

  const program = profile.program || {};
  const baseCurrency = root.querySelector('[data-bb-base-currency]');
  if (baseCurrency && program.baseCurrency) baseCurrency.textContent = program.baseCurrency;

  renderCanonicalTiers(root, profile);
  renderCanonicalRewards(root, profile);
  renderCanonicalActivity(root, profile);
  renderCanonicalReferral(root, profile);
  centerCurrentTier(root);
};

const hydratePublicProgram = (root, program) => {
  renderCanonicalTiers(root, program);
  renderCanonicalRewards(root, program);
};

const loadPublicProgram = async (root) => {
  if (globalThis.Shopify?.designMode || root.dataset.backendReady !== 'true') return;
  const endpoint = root.dataset.configEndpoint;
  if (!endpoint) return;
  try {
    const response = await fetch(endpoint, {credentials: 'same-origin', headers: {Accept: 'application/json'}});
    const program = await response.json().catch(() => ({}));
    if (!response.ok) throw new Error(program.message || 'Loyalty catalogue is temporarily unavailable.');
    hydratePublicProgram(root, program);
  } catch (error) {
    const unavailable = 'Verified loyalty details are temporarily unavailable. Please contact Support if you need help with your MP or a reward.';
    for (const selector of ['[data-bb-tier-track]', '.bb-rewards-redeem__track']) {
      const track = root.querySelector(selector);
      if (!track) continue;
      const message = document.createElement('p');
      message.textContent = unavailable;
      track.replaceChildren(message);
    }
    rewardsStatus(root, unavailable, true);
  }
};

const loadVerifiedProfile = async (root) => {
  if (globalThis.Shopify?.designMode || root.dataset.backendReady !== 'true' || root.dataset.customerAuthenticated !== 'true') return;
  const endpoint = root.dataset.profileEndpoint;
  if (!endpoint) return;
  try {
    const response = await fetch(endpoint, {
      credentials: 'same-origin',
      headers: {Accept: 'application/json'},
    });
    const profile = await response.json().catch(() => ({}));
    if (!response.ok) throw new Error(profile.message || 'Loyalty profile is temporarily unavailable.');
    hydrateVerifiedProfile(root, profile);
  } catch (error) {
    rewardsStatus(root, error.message || 'Loyalty profile is temporarily unavailable.', true);
  }
};

const handleRedemption = async (root, button) => {
  if (button.disabled) return;
  const endpoint = button.dataset.endpoint;
  const rewardCode = button.dataset.rewardCode;
  if (!endpoint || !rewardCode) return;

  button.disabled = true;
  button.dataset.requestId ||= globalThis.crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2)}`;
  const selection = button.closest('[data-bb-reward-card]')?.querySelector('[data-bb-tee-selection]')?.value;
  rewardsStatus(root, 'SECURELY VALIDATING REDEMPTION…');

  try {
    const response = await fetch(endpoint, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'Idempotency-Key': `storefront:${button.dataset.requestId}`,
      },
      body: JSON.stringify({rewardCode, ...(selection ? {selection: {variantId: selection}} : {})}),
    });
    const payload = await response.json().catch(() => ({}));
    if (response.status === 409 && payload.code === 'selection_required') {
      const card = button.closest('[data-bb-reward-card]');
      const choices = Array.isArray(payload.eligibleProducts) ? payload.eligibleProducts : [];
      if (!card || !choices.length) throw new Error(payload.message || 'No eligible Tee is currently available.');
      let select = card.querySelector('[data-bb-tee-selection]');
      if (!select) {
        select = document.createElement('select');
        select.dataset.bbTeeSelection = '';
        select.setAttribute('aria-label', 'Eligible Tee and variant');
        choices.forEach((choice) => {
          const option = document.createElement('option');
          option.value = choice.variantId;
          option.textContent = `${choice.productTitle} — ${choice.variantTitle} · $${Number(choice.priceUsd).toFixed(2)} USD`;
          select.append(option);
        });
        card.insertBefore(select, button);
      }
      button.disabled = false;
      button.textContent = 'CONFIRM FREE TEE';
      rewardsStatus(root, payload.message || 'SELECT AN ELIGIBLE TEE.');
      return;
    }
    if (!response.ok) throw new Error(payload.message || 'Redemption could not be issued. No points were deducted.');
    rewardsStatus(root, payload.message || 'LOYALTY CLAIM ISSUED. REFRESHING YOUR VERIFIED BALANCE…');
    showRedemptionConfirmation(root, payload.message || 'Your loyalty claim was issued. Your verified balance and claim details are refreshing.');
    await loadVerifiedProfile(root);
  } catch (error) {
    rewardsStatus(root, error.message || 'Redemption could not be issued. No points were deducted.', true);
    button.disabled = false;
  }
};

const handleActionClaim = async (root, button) => {
  if (button.disabled) return;
  const actionKey = button.dataset.bbClaimAction;
  const endpoint = root.dataset.actionsEndpoint;
  if (!actionKey || !endpoint) return;
  const card = button.closest('[data-bb-earn-action]');
  const orderId = card?.querySelector('[data-bb-survey-order]')?.value;
  const rating = Number(card?.querySelector('[data-bb-survey-rating]')?.value);
  button.disabled = true;
  button.setAttribute('aria-busy', 'true');
  rewardsStatus(root, 'VERIFYING ACTION…');
  try {
    const response = await fetch(`${endpoint}/claim`, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {'Content-Type': 'application/json', Accept: 'application/json'},
      body: JSON.stringify({actionKey, ...(actionKey === 'post-purchase-survey' ? {orderId, rating} : {})}),
    });
    const payload = await response.json().catch(() => ({}));
    if (!response.ok) throw new Error(payload.message || 'The action could not be claimed.');
    rewardsStatus(root, payload.alreadyClaimed ? 'ACTION WAS ALREADY CLAIMED.' : `+${formatPoints(payload.pointsAwarded)} SPENDABLE MP ADDED.`);
    button.textContent = 'CLAIMED ✓';
    if (!payload.alreadyClaimed && Number(payload.pointsAwarded) > 0) {
      root.dispatchEvent(new CustomEvent('sm:reward-claimed', {detail: {actionKey, points: Number(payload.pointsAwarded), anchor: button}}));
    }
    await Promise.all([loadEarningActions(root), loadVerifiedProfile(root)]);
  } catch (error) {
    rewardsStatus(root, error.message || 'The action could not be claimed.', true);
    button.disabled = false;
  } finally {
    button.removeAttribute('aria-busy');
  }
};

const copyReferral = async (root, button) => {
  const url = button.dataset.referralUrl;
  if (!url) return;
  try {
    await navigator.clipboard.writeText(url);
    rewardsStatus(root, 'REFERRAL LINK COPIED.');
  } catch {
    rewardsStatus(root, 'COPY FAILED. SELECT THE LINK MANUALLY.', true);
  }
};

const shareReferral = async (root, button) => {
  const url = button.dataset.referralUrl;
  if (!url) return;
  if (navigator.share) {
    await navigator.share({ title: 'Saint Mykonos Loyalty', text: 'Join Saint Mykonos through my verified referral.', url }).catch(() => {});
  } else {
    await copyReferral(root, button);
  }
};

const centerCurrentTier = (dashboard) => {
  if (!window.matchMedia('(max-width: 1099px)').matches) return;
  const track = dashboard.querySelector('.bb-rewards-tiers__track');
  const currentTier = track?.querySelector('.bb-rewards-tier.is-current');
  if (!track || !currentTier) return;

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  window.requestAnimationFrame(() => {
    track.scrollTo({
      left: Math.max(0, currentTier.offsetLeft - ((track.clientWidth - currentTier.clientWidth) / 2)),
      behavior: reducedMotion ? 'auto' : 'smooth',
    });
  });
};

const initializeRewards = (root = document) => {
  root.querySelectorAll('[data-bb-rewards]').forEach((dashboard) => {
    if (dashboard.dataset.bbRewardsReady === 'true') return;
    dashboard.dataset.bbRewardsReady = 'true';
    centerCurrentTier(dashboard);
    loadPublicProgram(dashboard).then(() => loadVerifiedProfile(dashboard));
    loadEarningActions(dashboard);
    loadLeaderboard(dashboard);
    dashboard.querySelector('[data-bb-leaderboard-period]')?.addEventListener('change', (event) => {
      loadLeaderboard(dashboard, event.currentTarget.value);
    });
    dashboard.addEventListener('click', (event) => {
      const redeem = event.target.closest('[data-bb-redeem]');
      if (redeem) return handleRedemption(dashboard, redeem);
      const action = event.target.closest('[data-bb-claim-action]');
      if (action) return handleActionClaim(dashboard, action);
      const copy = event.target.closest('[data-bb-copy-referral]');
      if (copy) return copyReferral(dashboard, copy);
      const share = event.target.closest('[data-bb-share-referral]');
      if (share) return shareReferral(dashboard, share);
    });
  });
};

document.addEventListener('DOMContentLoaded', () => initializeRewards());
document.addEventListener('shopify:section:load', (event) => initializeRewards(event.target));
